import { FC, useContext, useMemo } from 'react';
import { Formik } from 'formik';
import { Alert, AlertDescription, AlertIcon, Checkbox } from '@chakra-ui/react';
import { keys, pickBy } from 'lodash';
import { TableDrawer, TableContext, TableDrawerName } from '.';
import { CbButton } from '../Buttons/CbButton';
import styles from './ColumnVisibilityDrawer.module.css';
export const ColumnVisibilityDrawer: FC = () => {
  const {
    closeDrawer,
    columnInfo: {
      allColumns,
      setVisibleColumns,
      visibleColumns
    }
  } = useContext(TableContext);
  const displayedColumns = useMemo(() => allColumns.filter(col => !!col.name), [allColumns]);
  const allColumnsEnabled = useMemo(() => allColumns.reduce((acc, col) => ({
    ...acc,
    [col.id]: true
  }), {}), [allColumns]);
  const disableableColumnsDisabled = useMemo(() => allColumns.reduce((acc, col) => ({
    ...acc,
    [col.id]: col.primary || !col.name
  }), {}), [allColumns]);
  const initialValues: Record<string, boolean> = allColumns.reduce((acc, col) => ({
    ...acc,
    [col.id]: visibleColumns.includes(col.id)
  }), {});
  const onSubmit = (values: Record<string, boolean>) => {
    const newVisibleColumns = keys(pickBy(values));
    setVisibleColumns(newVisibleColumns);
    closeDrawer();
  };
  return <TableDrawer name={TableDrawerName.ColumnVisibility} data-sentry-element="TableDrawer" data-sentry-component="ColumnVisibilityDrawer" data-sentry-source-file="ColumnVisibilityDrawer.tsx">
      <Formik initialValues={initialValues} onSubmit={onSubmit} data-sentry-element="Formik" data-sentry-source-file="ColumnVisibilityDrawer.tsx" data-sentry-element="Formik" data-sentry-element="Formik">
        {({
        dirty,
        handleSubmit,
        setFieldValue,
        setValues,
        values
      }) => {
        const handleAll = () => setValues(allColumnsEnabled);
        const handleClear = () => setValues(disableableColumnsDisabled);
        return <>
              <Alert className={styles.helpText}>
                <AlertIcon boxSize="18px" color="chonky.500" />
                <AlertDescription>
                  Hiding a column will also remove any related filters, sorting
                  or search capabilities
                </AlertDescription>
              </Alert>
              <div className={styles.shortcuts}>
                <CbButton onClick={handleAll} size="sm" variant="link">
                  All
                </CbButton>
                <CbButton onClick={handleClear} size="sm" variant="link">
                  Clear
                </CbButton>
              </div>
              <div className={styles.columns}>
                {displayedColumns.map(col => <div className={styles.checkbox}>
                    <Checkbox isChecked={values[col.id]} isDisabled={col.primary} onChange={({
                target: {
                  checked
                }
              }) => setFieldValue(col.id, checked)}>
                      {col.name}
                    </Checkbox>
                  </div>)}
              </div>
              <div className={styles.apply}>
                <CbButton isDisabled={!dirty} onClick={() => handleSubmit()}>
                  Apply
                </CbButton>
              </div>
            </>;
      }}
      </Formik>
    </TableDrawer>;
};